import { ChangePassword } from './ChangePassword';
import { connect } from 'react-redux';
import {
  dashboardViewActions,
  dashboardViewErrorSel,
  dashboardViewIsPendingSel,
  dashboardCurrentPasswordSel,
  dashboardNewPasswordRepeatSel,
  dashboardNewPasswordSel,
  dashboardNewPasswordValidationSel
} from 'src/store/modules/dashboardview';

const mapStateToProps = (state: any) => {
  return {
    isLoading: dashboardViewIsPendingSel(state),
    hasError: dashboardViewErrorSel(state).hasFailed,
    currentPassword: dashboardCurrentPasswordSel(state),
    newPassword: dashboardNewPasswordSel(state),
    newPasswordRepeat: dashboardNewPasswordRepeatSel(state),
    passwordValidation: dashboardNewPasswordValidationSel(state)
  };
};

const mapDispatchToProps = (dispatch: any): IDispatchFromProps => ({
  onCurrentPasswordChange: (value: string) =>
    dispatch(dashboardViewActions.setCurrentPassword(value)),
  onNewPasswordChange: (value: string) =>
    dispatch(dashboardViewActions.setNewPassword(value)),
  onNewPasswordRepeatChange: (value: string) =>
    dispatch(dashboardViewActions.setNewPasswordRepeat(value)),
  onChangePassword: (cb?: (result: boolean) => void) =>
    dispatch(dashboardViewActions.changePassword(cb)),
  onClearError: () => dispatch(dashboardViewActions.setError())
});

export const pureComponent = ChangePassword;
export default connect(mapStateToProps, mapDispatchToProps)(ChangePassword);

interface IDispatchFromProps {
  onCurrentPasswordChange(value: string): void;
  onNewPasswordChange(value: string): void;
  onNewPasswordRepeatChange(value: string): void;
  onChangePassword(cb?: (result: boolean) => void): void;
  onClearError(): void;
}
